import { useContext, useEffect, useState } from "react"
import { StateOptionsInterface } from "../../models/axiosModels"
import agent from "../../Services/api"
import { GlobalUserContext, GlobalUserContextPayload } from "../../Context/GlobalUserDetailContext"
import { useSnackbar } from "../Layout/GlobalSnackbar/GlobalSnackbar"

const useStateOptions = () => {
    const {
        setFlagLoader
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const { showSnackbar } = useSnackbar();

    const [stateOptions, setStateOptions] = useState<StateOptionsInterface[]>([])

    const getStateOptions = async () => {
        try {
            const response = await agent.getStateOptions.get();
            if (response.status) {
                setStateOptions(response?.data?.states)
            }
            else {
                console.log("Error in response", response);
                showSnackbar("Error fetching states", 'error')
            }
        } catch (error) {
            console.error("Error fetching states", error);
            showSnackbar("Something Went Wrong", 'error')
        }
    }

    return { stateOptions, getStateOptions }
}

export default useStateOptions